// Baramulla location images
// Automatically import all images from the baramulla folder
// For now, use fallback images until actual baramulla images are added
// import fallbackEvents from "../fallback/events.jpg";
// import fallbackFacilities from "../fallback/facilities.jpg";

// When you add actual baramulla images, uncomment this code:

const baramullaImages = require.context(
  "./",
  false,
  /\.(jpg|jpeg|png|gif|webp|JPG|JPEG|PNG|GIF|WEBP)$/i
);

const images = baramullaImages
  .keys()
  .map((key) => baramullaImages(key))
  .sort((a, b) => {
    const nameA = a.split("/").pop().split(".")[0];
    const nameB = b.split("/").pop().split(".")[0];
    return nameA.localeCompare(nameB, undefined, { numeric: true });
  });

// For now, use fallback images
// const images = [fallbackEvents, fallbackFacilities];

export default images;
